<template>
  <div @click="onClose" id="sideBarModalComponent" class="wrapper" v-if="open">
    <div :class="{wrapper_body: true, open: open}">
      <div class="loading_div" v-if="loading">
        <pulse-loader :loading="loading" :color="color" class="text-center"/>
      </div>
      <div v-if="!loading && userWebSettings" class="modal_body">
        <div>
          <div class="from-group row">
            <label for="" class="col-sm-4">Имя</label>
            <div class="col-md-8">
              <input type="text" disabled v-model="$currentUser.name" class="form-control">
            </div>
          </div>
          <!--          <div class="from-group row">-->
          <!--            <label for="" class="col-sm-4">Телефон</label>-->
          <!--            <div class="col-md-8">-->
          <!--              <input type="text" disabled v-model="$currentUser.phone" class="form-control">-->
          <!--            </div>-->
          <!--          </div>-->
          <!--          <div class="from-group row">-->
          <!--            <label for="" class="col-sm-4">Email</label>-->
          <!--            <div class="col-md-8">-->
          <!--              <input type="text" disabled v-model="$currentUser.email" class="form-control">-->
          <!--            </div>-->
          <!--          </div>-->
        </div>
        <hr>
        <div>
          <div class="form-check">
            <input type="checkbox" id="ch_1" v-model="userWebSettings.incomeCalls">
            <label class="pointer" for="ch_1">Показывать окно с входящими звонками</label>
          </div>
          <div class="form-check">
            <input type="checkbox" id="ch_2" v-model="userWebSettings.newOrder">
            <label class="pointer" for="ch_2">Показывать уведомление о новых заявках</label>
          </div>
          <div class="form-check">
            <input type="checkbox" id="ch_3" v-model="userWebSettings.notificationSound">
            <label class="pointer" for="ch_3">Использовать звук для уведомлений</label>
          </div>
          <template v-if="manageChatMessages">
            <div class="form-check">
              <input type="checkbox" id="ch_4" v-model="userWebSettings.showChatMessages">
              <label class="pointer" for="ch_4">Показывать сообщения с чатов</label>
            </div>
            <div class="form-check">
              <input type="checkbox" :disabled="!userWebSettings.showChatMessages" id="ch_5"
                     v-model="userWebSettings.soundChatMessages">
              <label class="pointer" for="ch_5">Использовать звук для сообщений с чата</label>
            </div>
          </template>
        </div>
        <div class="text-right">
          <LoadingButton
            title="Сохранить"
            className="btn btn-success"
            :loading="btnLoading"
            :onClick="updateSettings"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import api from '@/api'
import LoadingButton from "@/components/buttons/LoadingButton";

export default {
  components: {
    LoadingButton,
  },
  props: ['modalData', 'onModalClose'],
  data() {
    return {
      color: '#5BBFDE',
      loading: true,
      btnLoading: false,
      open: false,
      userWebSettings: null,
      manageChatMessages: false,
    }
  },
  computed: {
    $currentUser() {
      return this.$store.getters["user/currentUser"];
    }
  },
  watch: {
    '$userSettings': {
      handler: function (val, oldVal) {
        this.openUserSettings(val);
      },
      deep: true
    },
  },
  created() {
    this.manageChatMessages = this.$currentUserRoles.includes('clientChatManager');
  },
  methods: {
    async updateSettings() {
      if (this.btnLoading) return;
      this.btnLoading = true;
      const {data} = await api.post('users/settings', {
        settings: this.userWebSettings
      });
      if (data.success) {
        toastr['success'](data.message || 'Сохранено!');
        this.$store.dispatch('user/setUserSettings', {webSettings: this.userWebSettings});
        this.btnLoading = false;
        this.onClose(null, true);
      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.btnLoading = false;
    },
    async openUserSettings(settings) {
      if (!settings.openModal) return;
      const body = document.getElementsByTagName('body')[0];
      body.style.overflow = "hidden";
      this.loading = true;
      this.open = true;
      const {data} = await api.index('users/settings');
      if (data.success) {
        if (data.webSettings && Object.keys(data.webSettings).length) {
          this.userWebSettings = data.webSettings
        } else {
          this.userWebSettings = {
            incomeCalls: true,
            newOrder: false,
            notificationSound: false,
            showChatMessages: false,
            soundChatMessages: false,
          };
        }

      } else {
        toastr['warning'](data.message || 'Ошибка!');
      }
      this.loading = false;
    },
    disableLoading() {
      this.loading = false;
    },
    onClose(e, global = false) {
      if (global || e && e.target && e.target.id === 'sideBarModalComponent') {
        // if (e.target.id === 'sideBarModalComponent') {
        const body = document.getElementsByTagName('body')[0];
        body.style.overflow = "auto";
        this.open = false;
      }
    }
  }
}

</script>

<style scoped>
.modal_body {
  padding: 50px;
}

.loading_div {
  position: absolute;
  top: 50%;
  left: 50%;
}

.wrapper_body.open {
  /*left: calc(100% - 300px);*/
  left: 25%;
  transition: all 0.3s ease 0s;
}

.wrapper_body {
  position: relative;
  transition: all 0.3s ease 0s;
  background-color: white;
  width: 75%;
  left: 100%;
  min-height: 100%;
  z-index: 9999;
}

.wrapper {
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: fixed;
  overflow-x: hidden;
  overflow-y: auto;
  z-index: 9999;
  transition: all 0.3s ease 0s;
  background-color: rgba(0, 0, 0, 0.5);
}
</style>
